export default "__VITE_ASSET__1ee67123__"